/* globals angular */
(function () {
  'use strict';

  /*@ngInject*/
  function EditPanelCtrl ( $rootScope, $q, $filter, $mdToast, AtendimentoResource, Pedido, mdPanelRef, Endereco, localStorageService) {

    var ctrl= this;

    ctrl.simulateQuery = false;
    ctrl.isDisabled = false;
    ctrl.isLoading = false;
    ctrl.nfeError = false;
    ctrl.data.destinatario.enderecoAntigo = Object.assign({}, ctrl.data.destinatario.endereco);
    ctrl.data.destinatario.endereco.estado = ctrl.data.destinatario.endereco.uf;
    ctrl.observation = "";

    ctrl.updateNFE = function(nfe) {
      ctrl.isLoading = true;
      ctrl.nfeError = false;
      Pedido.updateNFE(ctrl.data.id, nfe)
      .then(function() {
        return ctrl.openZendeskTicket('Chave anterior: ' + ctrl.data.nfe + ' Chave atual: ' + nfe);
      })
      .then(function(data) {
        return Pedido.updateSituation(ctrl.data.id, data.id);
      }).then(function (data) {
        $rootScope.$emit('reload');
        $rootScope.$emit('closeModal');
        mdPanelRef.close();
        ctrl.isLoading = false;
      })
      .catch(function(err) {
        showAlert('Houve um erro ao corrigir a encomenda, por favor, tente novamente mais tarde.');
        $rootScope.$emit('closeModal');
        if(err.status === 422) {
          ctrl.isLoading = false;
          ctrl.nfeError = true;
        }
      });
    };

    ctrl.updateEndereco = function(form) {

      if (form.$invalid) {
        return;
      }

      var enderecoAntigo = JSON.stringify(ctrl.data.destinatario.enderecoAntigo);
      var enderecoNovo = JSON.stringify(ctrl.data.destinatario.endereco);

      ctrl.isLoading = true;
      ctrl.data.destinatario.endereco.codigoPostal = ctrl.data.destinatario.endereco.cep;
      Pedido.updateEndereco(ctrl.data.id, ctrl.data.destinatario.endereco)
      .then(function(){
        return ctrl.openZendeskTicket(
          'Endereço anterior: ' +  enderecoAntigo +
          '\n Endereço atual: '  + enderecoNovo +
          '\n Observação: ' + ctrl.observation
        );
      })
      .then(function(data){
        return Pedido.updateSituation(ctrl.data.id, data.id);
      })
      .then(function() {
        $rootScope.$emit('reload');
        mdPanelRef.close();
        ctrl.isLoading = false;
      })
      .catch(function(err){
        ctrl.isLoading = false;
        showAlert('Houve um erro ao corrigir a encomenda, por favor, tente novamente mais tarde.');
      });
    };

    ctrl.openZendeskTicket = function(mensagem) {
      if(ctrl.data.situacao.codigo === 'Nova'){
        return $q.resolve({ticket: {id: null}});
      }

      var user = localStorageService.get('user');
      var email = user.email;

      var ticket = new AtendimentoResource({
        comment: mensagem !== null ? mensagem : 'Divergência respondida',
        tags: ['origem-paineldeocorrencias'],
        trackingCode: ctrl.data.rastreamento.codigoMandae,
        subject: ctrl.data.rastreamentoRemessa.descricaoEvento,
        contactEmail: email,
        divergenceType: ctrl.data.rastreamentoRemessa.descricaoEvento,
        occurrenceType: ctrl.data.rastreamentoRemessa.descricaoEvento,
      });

      return ticket.$save();
    };

    this.getLocation = function (address) {
      this.buscandoOn = false;
      if (!isNaN(address.replace('-', ''))) {
        address = address.replace('-', '');
      }
      return Endereco.getAddress(address.toLowerCase())
        .then(function (data) {
          ctrl.buscandoOn = true;
          if (data.usouSugestao) {
              var sugestao = data.enderecosEncontrados;
              var obj = {
                  'enderecoFormatado': 'Se você não encontrou o endereço, busque pelo CEP',
                  'desabilita': true
              };
              sugestao.unshift(obj);
              return sugestao;
            } else {
              return data.enderecosEncontrados;
            }
        })
      .catch(function (err) {
          return [{ 'enderecoFormatado': err.data.erro, 'desabilita': true }];
        });
    };

    ctrl.formatCep = function (cep) {
      return $filter('cep')(cep);
    };

    ctrl.preencheEndereco = function (item) {
        ctrl.data.destinatario.endereco.cep = item.cep;
        ctrl.data.destinatario.endereco.logradouro = item.logradouro;
        ctrl.data.destinatario.endereco.numero = item.numero ? item.numero : null;
        ctrl.data.destinatario.endereco.bairro = item.bairro;
        ctrl.data.destinatario.endereco.cidade = item.cidade;
        ctrl.data.destinatario.endereco.uf = item.estado;
        ctrl.data.destinatario.endereco.estado = item.estado;
    };

    function showAlert(content) {
      var toast = $mdToast.simple()
        .textContent(content)
        .highlightAction(true)
        .parent('[data-container="toast"]')
        .position('top right')
        .hideDelay(5000);

      return $mdToast.show(toast);
    }

  }

  angular
      .module('mandaeApp')
      .controller('EditPanelCtrl', EditPanelCtrl);

}());
